import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Modal, Box, TextField, Chip, Typography } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../../Styles/CreatePostUi/CreatePost.css';
import CustomAutocomplete from './CustomAutoComplete';
import Loader from '../../../Components/Loader/Loader';
import axiosUserInstance from '../../../axiosUserInstance';
import axiosVendorInstance from '../../../axiosVendorInstance';
import UploadImgIcon from '../../../assets/svg/UploadImgIcon';
import Slider from 'react-slick';
import LeftSliderArrow from '../../../assets/leftSliderArrow.svg';
import RightSliderArrow from '../../../assets/RightSliderArrow.svg';
import ChangeImgOrVideo from '../../../assets/ChangeImageOrVideo.svg';
import { IoPlayOutline } from 'react-icons/io5';
import NotificationIcon from '../../../assets/svg/notificationIcon';
import Notification from '../../User/Notification/Notification';
import BackIcon from '../../../assets/svg/backIcon';
import CloseIcon from '../../../assets/svg/closeIcon';

const CreatePost = ({
    openInitialPopup,
    setOpenInitialPopup,
    selectedFiles,
    setSelectedFiles,
    handleCloseModal,
    isEditMode = false,
    postId
}) => {
    const [selectedFilter, setSelectedFilter] = useState({
        label: 'Original',
        class: 'original',
    });
    const [description, setDescription] = useState('');
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [restaurantOptions, setRestaurantOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [menuItemsOptions, setMenuItemsOptions] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState('');
    const [selectedMenuItem, setSelectedMenuItem] = useState('');
    const [menuLoading, setMenuLoading] = useState(false);
    const [allMenuItems, setAllMenuItems] = useState([]);
    const [itemIds, setItemIds] = useState();
    const [menuItemSearchQuery, setMenuItemSearchQuery] = useState(null);
    const [vendorId, setVendorId] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isPlaying, setIsPlaying] = useState(false);
    const [NotificationOverlay, setNotificationOverlay] = useState(false);
    const [notificationcount, setNotificationCount] = useState();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [tagError, setTagError] = useState('');
    const containerRef = useRef(null);
    const imageRef = useRef(null);
    const fileInputRef = useRef(null);
    const overlayRef = useRef(null);
    const videoRef = useRef(null);
    const videoLoadedRef = useRef(false);
    const [mediaPreviewUrl, setMediaPreviewUrl] = useState(null);
    const [isMediaImage, setIsMediaImage] = useState(false);
    const [cachedMediaUrl, setCachedMediaUrl] = useState(null);
    
    useEffect(() => {
        if (
            selectedFiles?.type?.startsWith('video/') &&
      videoRef.current &&
      !videoLoadedRef.current
        ) {
            videoRef.current.load();
            videoLoadedRef.current = true;
        }
    }, [selectedFiles]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    

    const closenotificationoverlay = () => {
        setNotificationOverlay(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 601);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const PrevArrow = ({ onClick }) => {
        return (
            <div className='custom-arrow left-arrow' onClick={onClick}>
                <img src={LeftSliderArrow} alt='' />
            </div>
        );
    };

    // Custom Right Arrow Component
    const NextArrow = ({ onClick }) => {
        return (
            <div className='custom-arrow right-arrow' onClick={onClick}>
                <img src={RightSliderArrow} alt='' />
            </div>
        );
    };

    let slidesToShow = 3.7;

    if (windowWidth < 384) {
        slidesToShow = 3;
    } else if (windowWidth <= 484) {
        slidesToShow = 3.9;
    } else if (windowWidth > 484 && windowWidth < 600) {
        slidesToShow = 5;
    } else if (windowWidth >= 600 && windowWidth < 750) {
        slidesToShow = 3;
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!description || !description.trim()) {
            newErrors.description = 'Description is required.';
        } else if (description.length > 2200) {
            newErrors.description = 'Description cannot exceed 2200 characters.';
        }

        if (!selectedRestaurant || !selectedRestaurant.trim()) {
            newErrors.selectedRestaurant = 'Restaurant name is required.';
        }

        if (!menuItemSearchQuery || !menuItemSearchQuery.trim()) {
            newErrors.menuItemSearchQuery = 'Menu item is required.';
        } else if (
            !menuItemsOptions
                .map((option) => option?.Item_name)
                ?.includes(menuItemSearchQuery !== '' && menuItemSearchQuery)
        ) {
            newErrors.menuItemSearchQuery =
        'Selected menu item not found in restaurant.';
        }

        if (!isEditMode && !selectedFiles) {
            // For create mode, require a file
            newErrors.selectedFiles = 'Please upload an image or video.';
        } else if (isEditMode && !selectedFiles && !mediaPreviewUrl) {
            // For edit mode, require either existing media or new file
            newErrors.selectedFiles = 'Please upload an image or video.';
        } else if (selectedFiles && !['image/', 'video/'].some((type) => selectedFiles.type.startsWith(type))) {
            newErrors.selectedFiles = 'Invalid file type. Please select an image or video.';
        }

        if (tags.length > 30) {
            newErrors.tags = 'You can only add up to 30 tags.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClose = () => {
        setOpenInitialPopup(false);
        
        // Safely reset files if setSelectedFiles exists
        if (typeof setSelectedFiles === 'function') {
            setSelectedFiles(null);
        }
        
        // Reset all other states
        setDescription('');
        setTags([]);
        setSelectedRestaurant('');
        setMenuItemSearchQuery('');
        
        setSelectedFilter({ label: 'Original', class: 'original' });
        setErrors({});
        
        // Optional close modal callback
        if (typeof handleCloseModal === 'function') {
            handleCloseModal();
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                selectedFiles: 'Please select a valid image or video file.',
            }));
            fileInputRef.current.value = null;
            return;
        }
    
        // Clear any previous errors
        setErrors((prevErrors) => ({
            ...prevErrors,
            selectedFiles: '',
        }));
    
        // Handle video-specific logic
        if (file.type.startsWith('video/')) {
            videoLoadedRef.current = false;
        }
    
        // Update the selected file and preview URL
        if (typeof setSelectedFiles === 'function') {
            setSelectedFiles(file);
            const newUrl = URL.createObjectURL(file);
            setCachedMediaUrl(newUrl);
            setMediaPreviewUrl(newUrl);
            // setMediaPreviewUrl(URL.createObjectURL(file)); // Set preview URL immediately
            setIsMediaImage(file.type.startsWith('image/')); // Determine if it's an image
            setSelectedFilter({ label: 'Original', class: 'original' }); // Reset filter to original
        } else {
            console.warn('setSelectedFiles not available - using local state');
        }
        fileInputRef.current.value = null;
    };
    const handlePostSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }

        try {
            document.querySelector('.topbar-container').style.zIndex = '1';
            setIsLoading(true);
            const formData = new FormData();

            if (selectedFiles) {
                // Only append new file if it's a different one
                if (!isEditMode || (isEditMode && typeof selectedFiles !== 'string')) {
                    formData.append('files', selectedFiles);
                }
            }

            formData.append('description', description);
            formData.append('vendor_id', vendorId);
            formData.append('tags', tags);
            formData.append('item_ids', itemIds);
            formData.append('posted_as_role_id', 3);
            formData.append('filter', selectedFilter.class);

            if (itemIds !== 'Item not found') {
                setIsLoading(true);
                if (isEditMode && postId) {
                    await axiosUserInstance.put(`/posts/${postId}`, formData);
                } else {
                    await axiosUserInstance.post('/posts', formData);
                }
                setIsLoading(false);
                setOpenInitialPopup(false);
                handleClose();

                window.location.reload();
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    menuItemSearchQuery: 'Selected menu item not found in restaurant',
                }));
            }

        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            setIsLoading(false);
            const topbar = document.querySelector('.topbar-container');
            if (topbar) {
                topbar.style.zIndex = '2';
            } else {
                console.warn('Element with class .topbar-container not found.');
            }
        }
    };


    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && inputValue.trim() !== '') {
            event.preventDefault();
            const newTag = inputValue.trim();
            setTagError('');

            if (tags.length >= 30) {
                setTagError('You can only add up to 30 tags.');
                return;
            }

            if (/\s/.test(newTag)) {
                setTagError('Hashtag cannot contain spaces.');
                return;
            }

            const validHashtagPattern = /^#?[A-Za-z0-9_]+$/;
            if (!validHashtagPattern.test(newTag)) {
                setTagError('Only letters, numbers, and underscores (_) allowed.');
                return;
            }

            if (newTag.length > 55) {
                setTagError('Hashtag cannot exceed 30 characters.');
                return;
            }

            if (tags.includes(newTag)) {
                setTagError('This tag already exists.');
                return;
            }

            setTags([...tags, newTag]);
            setInputValue('');
        }
    };

    const handleDelete = (tagToDelete) => {
        setTags(tags.filter((tag) => tag !== tagToDelete));
    };

    const handleSearch = async (query) => {
        if (query) {
            setLoading(true);
            try {
                const response = await axiosVendorInstance.get(
                    `/vendors/search/searchrestaurants/${query}`,
                    { skipAuth: true }
                );
                const restaurants = response?.data?.List_of_restaurants || [];
                setRestaurantOptions(restaurants);

            } catch (error) {
                console.error('Error fetching search results:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setRestaurantOptions([]);
            setSelectedRestaurant(null);
            setMenuItemsOptions([]);
            setMenuItemSearchQuery('');
        }
    };

    const handleSelectRestaurant = (value) => {
        if (!value) {
            setSelectedRestaurant(null);
            setMenuItemsOptions([]);
            setMenuItemSearchQuery('');
            return;
        }

        const selectedRestaurant = restaurantOptions.find(
            (restaurant) => restaurant?.Name === value
        );
        setSelectedRestaurant(selectedRestaurant?.Name || null);
        if (selectedRestaurant) {
            setVendorId(selectedRestaurant?.vendorid);
            handleSearchMenuItem(selectedRestaurant?.vendorid);
        }
    };

    const handleSelectMenuItem = (value) => {
        if (!value) {
            setMenuItemSearchQuery('');
            return;
        }
        const selectedRestaurant = allMenuItems.find(
            (menuItem) => menuItem?.Item_name === value
        );
        setSelectedMenuItem(selectedRestaurant?.Item_name || null);
        setMenuItemSearchQuery(selectedRestaurant?.Item_name || null);
    };

    const handleSearchMenuItem = async (vendorId) => {
        setMenuLoading(true);
        if (vendorId != undefined) {
            try {
                const response = await axiosVendorInstance.get(
                    `/vendors/menuitems/${vendorId}`,
                    { skipAuth: true }
                );
                const menuItems = response?.data?.menuItems || [];
                const matchingItem = menuItems.find(
                    (item) => item?.Item_name === selectedMenuItem
                );
                const relatedID = matchingItem ? matchingItem.ID : 'Item not found';
                setItemIds(relatedID);
                setAllMenuItems(menuItems);
                setMenuItemsOptions(menuItems);
            } catch (error) {
                console.error('Error fetching menu items:', error);
                setMenuItemsOptions([]);
                setAllMenuItems([]);
            } finally {
                setMenuLoading(false);
            }
        }
    };

    const handleMenuItemSearch = (query) => {
        setMenuItemSearchQuery(query);

        if (!query.trim() || query.trim().length <= 2) {
            setMenuItemsOptions(allMenuItems);
            return;
        }

        const filteredItems = allMenuItems.filter((item) =>
            item.Item_name.toLowerCase().includes(query.toLowerCase())
        );

        setMenuItemsOptions(filteredItems);
    };

    useEffect(() => {
        handleSearchMenuItem(vendorId);
    }, [selectedRestaurant, selectedMenuItem]);

    const fetchNotifications = async () => {
        try {
            const url = '/notifications/notifications';
            const res = await axiosUserInstance.get(url);
            setNotificationCount(res?.data?.notificationCount);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const images = [
        { label: 'Original', class: 'original' },
        { label: 'Brightness', class: 'brightness' },
        { label: 'Contrast', class: 'contrast' },
        { label: 'Saturation', class: 'saturation' },
        { label: 'Hue', class: 'hue' },
        { label: 'Blur', class: 'blur' },
        { label: 'Sepia', class: 'sepia' },
        { label: 'Grayscale', class: 'grayscale' },
        { label: 'Invert', class: 'invert' },
        { label: 'Opacity', class: 'opacity' },
        { label: 'Sharpen', class: 'sharpen' },
    ];

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        setDescription(value);

        if (value.trim() !== '' && value.length <= 2200) {
            setErrors((prevErrors) => ({ ...prevErrors, description: null }));
        }
    };
    
    useEffect(() => {
        const fetchPostDataForEdit = async () => {
            if (isEditMode && postId && openInitialPopup) {
                try {
                    setIsLoading(true);
                    const res = await axiosUserInstance.get(`/posts/sharepost/${postId}/0,0`);
                    setIsLoading(false);
                    const post = res?.data?.posts?.[0]?.Post_Information?.[0];
                    setDescription(post?.Post_Description || '');
                    setSelectedFilter(
                        images.find(img => img?.class === post?.Post_filter) || 
                        { label: 'Original', class: 'original' }
                    );
                    
                    // Handle media (image/video)
                    const attachmentKey = post?.Attachment_keys?.[0]?.Avatar_key;
                    let mediaUrl = '';
                    if (attachmentKey) {
                        try {
                            const parsed = JSON.parse(attachmentKey);
                            if (Array.isArray(parsed) && parsed[0]) {
                                mediaUrl = parsed[0];
                                // Check if it's an image or video
                                const isImage = /\.(jpeg|jpg|png|gif|webp|avif)$/i.test(mediaUrl);
                                setIsMediaImage(isImage);
                                setMediaPreviewUrl(mediaUrl);
                            }
                        } catch (e) {
                            console.error('Failed to parse media URL:', e);
                        }
                    }

                    if (post.Post_Tags) {
                        const parsedTags = post.Post_Tags.split(',').map(tag => tag.trim());
                        setTags(parsedTags);
                    }
                    
                    // Restaurant + MenuItem
                    // Handle restaurant and menu item
                    if (post?.Vendor_Info?.[0]) {
                        const vendorInfo = post?.Vendor_Info[0];
                    
                        // Set restaurant name directly as string (matches autocomplete expectation)
                        setSelectedRestaurant(vendorInfo?.Vendor_Name);
                        setVendorId(vendorInfo?.Vendor_ID);
                    
                        // Set menu item name if available
                        if (post?.Menu_items_Info?.[0]) {
                            const menuItemName = post?.Menu_items_Info[0]?.Menu_item_Name;
                            setMenuItemSearchQuery(menuItemName);
                            setSelectedMenuItem(menuItemName);
                        }
                    
                        // Load menu items for this restaurant
                        await handleSearchMenuItem(vendorInfo?.Vendor_ID);
                    }
                } catch (err) {
                    setIsLoading(false);
                    console.error('Error fetching post for edit:', err);
                }
            }
        };
        fetchPostDataForEdit();
    }, [isEditMode, postId, openInitialPopup]);

    const memoizedSliderContent = useMemo(() => {
        return images.map((img, index) => (
            <div
                key={index}
                className='image-slide'
                onClick={() => setSelectedFilter(img)}
            >
                <img
                    src={cachedMediaUrl || mediaPreviewUrl}
                    alt={img.label}
                    className={`slide-image ${img?.class}`}
                />
                <p
                    className={`label ${
                        selectedFilter.class === img?.class
                            ? 'selected-filter-label'
                            : ''
                    }`}
                >
                    {img.label}
                </p>
            </div>
        ));
    }, [cachedMediaUrl, mediaPreviewUrl, selectedFilter, images]);

    useEffect(() => {
        return () => {
            if (cachedMediaUrl) {
                URL.revokeObjectURL(cachedMediaUrl);
            }
            if (mediaPreviewUrl && !isEditMode) {
                URL.revokeObjectURL(mediaPreviewUrl);
            }
        };
    }, [cachedMediaUrl, mediaPreviewUrl, isEditMode]);

    if (!openInitialPopup) return null;
    if (isLoading) return <Loader />;

    const renderMediaPreview = () => {
        if (isEditMode && mediaPreviewUrl && (!selectedFiles || selectedFiles.length === 0)) {
            return isMediaImage ? (
                <img
                    src={mediaPreviewUrl}
                    className={selectedFilter?.class}
                    alt="Post preview"
                    onClick={(e) => e.preventDefault()}
                />
            ) : (
                <div className="video-container">
                    <video
                        ref={videoRef}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (videoRef.current) {
                                videoRef.current.paused 
                                    ? videoRef.current.play() 
                                    : videoRef.current.pause();
                                setIsPlaying(!isPlaying);
                            }
                        }}
                        
                    >
                        <source src={mediaPreviewUrl} type="video/mp4" />
                    </video>
                    {!isPlaying && (
                        <button onClick={handlePlay} className="play-btn">
                            <IoPlayOutline color="white" fontSize={34} />
                        </button>
                    )}
                </div>
            );
        } else {
            // For newly uploaded files (create mode or edit mode with new upload)
            if (selectedFiles) {
                const src = cachedMediaUrl || mediaPreviewUrl;
                if (selectedFiles.type.startsWith('image/')) {
                    return (
                        <img
                            src={src}
                            className={selectedFilter?.class}
                            alt="Uploaded content"
                        />
                    );
                } else {
                    return (
                        <div className="video-container">
                            <video
                                ref={videoRef}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (videoRef.current) {
                                        videoRef.current.paused 
                                            ? videoRef.current.play() 
                                            : videoRef.current.pause();
                                        setIsPlaying(!isPlaying);
                                    }
                                }}
                            >
                                <source src={src} type={selectedFiles.type} />
                            </video>
                            {!isPlaying && (
                                <button onClick={handlePlay} className="play-btn">
                                    <IoPlayOutline color="white" fontSize={34} />
                                </button>
                            )}
                        </div>
                    );
                }
            }

        }
        
        return (
            <div className="upload-section" onClick={(e) => {
                e.preventDefault();
                fileInputRef.current.click();
            }}>
                <UploadImgIcon />
                <p>Upload Your Video Or Photo</p>
            </div>
        );
    };

    return (
        <div>
            <Modal
                open={openInitialPopup}
                onClose={handleClose}
                style={{
                    backdropFilter: 'blur(10px)',
                    backgroundColor: '#2C3142B2 !important',
                }}
            >
                <Box className='post-module-popup'>
                    {isMobile ? (
                        <div className='create-post-header-mobile'>
                            <div className='back-post'>
                                <BackIcon onClick={handleClose} />
                                <h2 className='create-post-title-mobile'>{isEditMode ? 'Update Post': 'Create New Post'}</h2>
                            </div>
                            <div>
                                <NotificationIcon
                                    color={'white'}
                                    className='notification-icon'
                                    notificationcount={notificationcount}
                                    onClick={() => setNotificationOverlay(!NotificationOverlay)}
                                />
                                {NotificationOverlay && (
                                    <>
                                        <div className='arrow-to-point-notification'></div>
                                        <div className='notification-overlay' ref={overlayRef} style={{top:'70px'}}>
                                            <Notification closeOverlay={closenotificationoverlay} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className='create-post-header'>
                            <h2 className='create-post-title'>{isEditMode ? 'Update Post': 'Create New Post'}</h2>
                            <CloseIcon
                                size={30}
                                color='black'
                                onClick={handleClose}
                                className='close-icon'
                            />
                        </div>
                    )}
                    <div className='create-post-line'></div>
                    <div className='create-new-post' ref={containerRef}>
                        <div className='select-img-container-first-popup'>
                            <div
                                className={'img-video-select-container'}
                                ref={imageRef}
                            >
                                <input
                                    id='fileUpload'
                                    type='file'
                                    accept='image/*,video/*'
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                    ref={fileInputRef}
                                />
                                <div className='select-img-video-btn'>
                                    <div className="image-upload-part">
                                        {renderMediaPreview()}
                                        {(isEditMode && mediaPreviewUrl) || selectedFiles ? (
                                            <button
                                                className="change-img-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    fileInputRef.current.click();
                                                }}
                                            >
                                                <img src={ChangeImgOrVideo} alt="change-img" />
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            {errors.selectedFiles && (
                                <span style={{ color: 'red', fontSize: '10px' }}>
                                    {errors.selectedFiles}
                                </span>
                            )}
                            {(selectedFiles?.type?.startsWith('image/') || 
                                (isEditMode && isMediaImage && mediaPreviewUrl)) && (
                                <div className='image-slider-container'>
                                    <div className='slider-container'>
                                        <Slider {...settings}>
                                            {memoizedSliderContent}
                                        </Slider>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='post-details-1'>
                            <Box className='post-details-box'>
                                <div>
                                    <h2 className='post-details-name'>Post Details</h2>
                                    <TextField
                                        className='description-box'
                                        label='Description'
                                        variant='outlined'
                                        focused
                                        fullWidth
                                        multiline
                                        rows={3}
                                        placeholder='Enter Description'
                                        value={description}
                                        onChange={handleDescriptionChange}
                                        sx={{
                                            mb: '25px',
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    border: '1px solid #E5E5E5',
                                                },
                                            },
                                            '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline':
                        {
                            borderColor: 'red !important',
                        },
                                            '& .MuiFormLabel-root.Mui-error': {
                                                color: 'red !important',
                                            },
                                        }}
                                        error={!!errors.description}
                                        helperText={errors.description}
                                    />

                                    <Box className='tag-box-container'>
                                        <Typography variant='caption' className='tags-label'>
                      Tags
                                        </Typography>

                                        <Box className='tags-box'>
                                            {tags.map((tag, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tag}
                                                    onDelete={() => handleDelete(tag)}
                                                    sx={{ marginBottom: '4px' }}
                                                />
                                            ))}
                                            <TextField
                                                variant='standard'
                                                placeholder={
                                                    tags.length >= 30
                                                        ? ' '
                                                        : 'Enter a tag and press Enter'
                                                }
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                                onBlur={() => {
                                                    setInputValue('');
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{
                                                    flex: 1,
                                                    minWidth: '120px',
                                                }}
                                                disabled={tags.length >= 30}
                                            />
                                        </Box>
                                        {tagError && (
                                            <Typography variant='caption' color='error'>
                                                {tagError}
                                            </Typography>
                                        )}
                                    </Box>

                                    <div>
                                        <CustomAutocomplete
                                            id='restaurant-search-autocomplete'
                                            label='Restaurant Name'
                                            placeholder='Enter Restaurant Name'
                                            options={restaurantOptions}
                                            loading={loading}
                                            focused={true}
                                            onInputChange={handleSearch}
                                            onSelect={handleSelectRestaurant}
                                            value={selectedRestaurant || selectedRestaurant?.Name || ''}
                                            error={!!errors.selectedRestaurant}
                                            message={'No Restaurants available'}
                                            setErrors={setErrors}
                                            errors={errors}
                                        />

                                        <CustomAutocomplete
                                            id='menu-item-search-autocomplete'
                                            label='Menu Item'
                                            placeholder='select menu item'
                                            options={menuItemsOptions.map(
                                                (option) => option?.Item_name
                                            )}
                                            loading={menuLoading}
                                            focused={true}
                                            onInputChange={(value) => handleMenuItemSearch(value)}
                                            onSelect={handleSelectMenuItem}
                                            value={menuItemSearchQuery || ' '}
                                            disabled={!selectedRestaurant}
                                            error={!!errors.menuItemSearchQuery}
                                            message={'No Menu Items available'}
                                            setErrors={setErrors}
                                            errors={errors}
                                        />
                                    </div>
                                </div>
                                <div className='post-btn'>
                                    <button
                                        onClick={handlePostSubmit}
                                        className='next-btn-create-post'
                                    >
                    Post
                                    </button>
                                </div>
                            </Box>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default CreatePost;
